module.exports = __webpack_public_path__ + "static/phoneConcept-3ac03bedea451117551de083fb15ff8a.svg";